// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pool-picker .panel-title p[data-v-2a169196] {\n  font-size: 16px;\n  margin-bottom: 0px;\n}\n#pool-picker .panel-body[data-v-2a169196] {\n  padding: 1rem;\n  max-height: 280px;\n  overflow-y: auto;\n}\n#pool-picker .panel-footer[data-v-2a169196] {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n#pool-picker .empty[data-v-2a169196] {\n  text-align: center;\n}\n#pool-picker .empty i[data-v-2a169196] {\n  color: #e4eaec;\n  font-size: 72px;\n}", ""]);
// Exports
module.exports = exports;
